import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace, useNamespaceRoutes } from '@modules/permissions/composables';
import { usePermissionsStore } from '@modules/permissions/store';

import type {
  IAffiliatesPendingCountResponse,
} from '../types';
import {
  AFFILIATES_PENDING_COUNT_QUERY_KEY,
  AFFILIATES_PENDING_COUNT_URL,
  AFFILIATES_PENDING_PERMISSIONS,
} from '../constants';

export default function useAffiliatesPendingCountQuery(): IContextQueryResult<
  IAffiliatesPendingCountResponse,
  Error,
  number
> {
  const { fetchGet } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();
  const { isAdminRoute } = useNamespaceRoutes();
  const { hasPermission } = usePermissionsStore();

  return useContextQuery<
    IAffiliatesPendingCountResponse,
    Error,
    number
  >({
    queryKey: [AFFILIATES_PENDING_COUNT_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliatesPendingCountResponse>(
      AFFILIATES_PENDING_COUNT_URL,
      {
        signal,
        permission: AFFILIATES_PENDING_PERMISSIONS.SHOW,
      },
    ),
    select: (data) => data.count,
    enabled: computed(() => isAdminNamespace.value && isAdminRoute.value && hasPermission(AFFILIATES_PENDING_PERMISSIONS.SHOW).value),
  });
}
